// variabili di ambiente
export const { NODE_ENV, HOST, PORT, REACT_APP_API_URL, REACT_APP_STRIPE_API_KEY } = process.env;

declare global {
  interface Window {
    dataLayer: any;
    Trustpilot: any;
  }
}
